/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { InImageDTO } from "./InImageDTO";
import { InImageDTOFromJSON, InImageDTOFromJSONTyped, InImageDTOToJSON } from "./InImageDTO";
import type { PlatformRefDTO } from "./PlatformRefDTO";
import { PlatformRefDTOFromJSON, PlatformRefDTOFromJSONTyped, PlatformRefDTOToJSON } from "./PlatformRefDTO";
import type { SeoDTO } from "./SeoDTO";
import { SeoDTOFromJSON, SeoDTOFromJSONTyped, SeoDTOToJSON } from "./SeoDTO";

/**
 *
 * @export
 * @interface CreateProductDTO
 */
export interface CreateProductDTO {
  /**
   *
   * @type {string}
   * @memberof CreateProductDTO
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof CreateProductDTO
   */
  ean?: string;
  /**
   *
   * @type {PlatformRefDTO}
   * @memberof CreateProductDTO
   */
  platform: PlatformRefDTO;
  /**
   *
   * @type {boolean}
   * @memberof CreateProductDTO
   */
  live: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateProductDTO
   */
  slug: string;
  /**
   *
   * @type {InImageDTO}
   * @memberof CreateProductDTO
   */
  image?: InImageDTO;
  /**
   *
   * @type {SeoDTO}
   * @memberof CreateProductDTO
   */
  seo?: SeoDTO;
  /**
   *
   * @type {string}
   * @memberof CreateProductDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CreateProductDTO
   */
  specification?: string;
  /**
   *
   * @type {string}
   * @memberof CreateProductDTO
   */
  createdAt?: string;
}

/**
 * Check if a given object implements the CreateProductDTO interface.
 */
export function instanceOfCreateProductDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "title" in value;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "live" in value;
  isInstance = isInstance && "slug" in value;

  return isInstance;
}

export function CreateProductDTOFromJSON(json: any): CreateProductDTO {
  return CreateProductDTOFromJSONTyped(json, false);
}

export function CreateProductDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProductDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    title: json["title"],
    ean: !exists(json, "ean") ? undefined : json["ean"],
    platform: PlatformRefDTOFromJSON(json["platform"]),
    live: json["live"],
    slug: json["slug"],
    image: !exists(json, "image") ? undefined : InImageDTOFromJSON(json["image"]),
    seo: !exists(json, "seo") ? undefined : SeoDTOFromJSON(json["seo"]),
    description: !exists(json, "description") ? undefined : json["description"],
    specification: !exists(json, "specification") ? undefined : json["specification"],
    createdAt: !exists(json, "createdAt") ? undefined : json["createdAt"]
  };
}

export function CreateProductDTOToJSON(value?: CreateProductDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    title: value.title,
    ean: value.ean,
    platform: PlatformRefDTOToJSON(value.platform),
    live: value.live,
    slug: value.slug,
    image: InImageDTOToJSON(value.image),
    seo: SeoDTOToJSON(value.seo),
    description: value.description,
    specification: value.specification,
    createdAt: value.createdAt
  };
}
